import { Container, Grid, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import { congTacPhucVuSubMenus, CTPV_PACKAGE } from 'components/app-navigator/navMenus';
import React from 'react';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        minHeight: 'calc(100vh - 56px)',
        display: 'flex',
        paddingTop: '10%',
    },
    container: {
        height: '100%',
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        minHeight: 300,
        minWidth: 300,
        padding: theme.spacing(3),
    },
    listHeader: {
        fontSize: 24,
        fontWeight: 'bold',
    },
}));

function CongTacPhucVuPage() {
    const classes = useStyles();
    const history = useHistory();
    const reportItems = congTacPhucVuSubMenus.filter((item) => item.package === CTPV_PACKAGE.REPORT);
    return (
        <div className={classes.wrapper}>
            <Container maxWidth="md" className={classes.container}>
                <div className={classes.root}>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
                                        <ListItem className={classes.listHeader}>{CTPV_PACKAGE.REPORT}</ListItem>
                                        {reportItems.map((menu, index) => (
                                            <ListItem button onClick={() => history.push(menu.path)} key={index}>
                                                <ListItemIcon>{menu.icon}</ListItemIcon>
                                                <ListItemText primary={menu.title} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
}

export default CongTacPhucVuPage;
